
























import Vue, { PropType } from "vue"
import FilterDescription from "~/components/custom/search/FilterDescription.vue"
import { WorkingFormOption } from "~/clStores/projectSearchParameterOption"

export default Vue.extend({
  components: {
    FilterDescription,
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      required: true,
    },
    options: {
      type: Array as PropType<WorkingFormOption[]>,
      required: true,
    },
  },
  methods: {
    isSelected(workingFormId: number): boolean {
      return this.value.includes(workingFormId)
    },
    handleInput(selectedworkingFormId: number[]) {
      this.$emit("input", selectedworkingFormId)
    },
    select(workingFormId: number) {
      const newIds = this.isSelected(workingFormId)
        ? this.value.filter((v) => v !== workingFormId)
        : [...this.value, workingFormId]
      this.handleInput(newIds)
    },
  },
})
